import React, { useState, useEffect } from 'react';
// Libraries
import { Form, message } from 'antd';
// Components
import Button from '~/components/button';
import Card from '~/components/card';
import Loading from '~/components/loading';
import Divider from '~/components/divider';
// Questions
import BasicInformation from './components/BasicInformation';
// Utils
import SocialMeAPI from '~/utils/SocialMeAPI';

export default function StreetForm({ person, GetProfileAgain }) {
  const [form] = Form.useForm();
  const [callingAPI, setCallingAPI] = useState(false);
  const [loadingForm, setLoadingForm] = useState(true);

  useEffect(() => {
      setLoadingForm(false);
  }, [person]);

  async function EditProfile(data) {
    setCallingAPI(true);
    const params = {
      operation: ['Profile', 'Edit'],
      data:{
        name: data.name,
        social_name: data.name
      }
    };
    const response = await SocialMeAPI(params);
    if (response.success) {
      message.success('Perfil atualizado com sucesso!');
      GetProfileAgain();
    } else {
      message.error('Alguma coisa aconteceu...');
    }
    return setCallingAPI(false);
  }

  async function onFinish(data) {
    EditProfile(data);
  }
  if (loadingForm) {
    return (
      <Card>
        <Loading />
      </Card>
    );
  }

  return (
    <Form
      labelCol={{ xs: { span: 24 }, sm: { span: 24 } }}
      wrapperCol={{ xs: { span: 24 }, sm: { span: 24 } }}
      form={form}
      size="small"
      layout="vertical"
      onFinish={onFinish}
      scrollToFirstError
      initialValues={person}
      style={{ marginTop: 10 }}
    >
      <BasicInformation />

      <Divider style={{ margin: '10px 0px' }} />
      <Form.Item wrapperCol={{ xs: { span: 24 }, sm: { span: 24 } }}>
        <Button
          loading={callingAPI}
          style={{ float: 'right' }}
          size="default"
          type="primary"
          htmlType="submit"
        >
          Atualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
